import { LineItemNumericCalculatorField } from "components/formFields/LineItemNumericCalculatorField";
import { LineTableCell } from "components/formFields/LineTableCell";

import { LINE_ITEM_METADATA } from "editConfig";

export function LineReceived(props) {
  const { value, onValueChange, objectType, lineReadOnly = false } = props;

  const metadata = LINE_ITEM_METADATA[objectType].received;

  return (
    <LineTableCell sx={{ minWidth: "6rem" }}>
      <LineItemNumericCalculatorField
        name="received"
        value={value}
        onValueChange={onValueChange}
        metadata={metadata}
        lineReadOnly={lineReadOnly}
      />
    </LineTableCell>
  );
}
